import AddToPhotosOutlinedIcon from '@mui/icons-material/AddToPhotosOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import FormatListNumberedOutlinedIcon from '@mui/icons-material/FormatListNumberedOutlined';
import PlaylistAddOutlinedIcon from '@mui/icons-material/PlaylistAddOutlined';
import { Slide } from '@mui/material';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';

const NAV_SURFACE = '#ffffff';
const SHEET_SURFACE = '#f5f5f5';

const TaskManager_AdminMenu = ({ tab1, tab2, tab3, tab4 }) => {
  const [value, setValue] = useState(0); // To manage active tab
  const [isBoxOpen, setIsBoxOpen] = useState(false); // To toggle box visibility
  const footerRef = useRef(null); // Ref for the BottomNavigation component
  const slidingBoxRef = useRef(null); // Ref for the sliding box

  const handleOpenBox = newValue => {
    // If the same tab is clicked, toggle the box
    if (value === newValue && isBoxOpen) {
      setIsBoxOpen(false);
    } else {
      setIsBoxOpen(true); // Open the box
      setValue(newValue); // Set the active tab value
    }
  };

  const stopPropagation = e => {
    e.stopPropagation();
  };

  return (
    <div
      ref={footerRef}
      className="footer-wrapper mx-auto"
      style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 10, backgroundColor: NAV_SURFACE }}
    >
      {/* Bottom Navigation */}
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => {
          handleOpenBox(newValue);
        }}
        showLabels
        sx={{
          marginLeft: '0px',
          marginRight: '0px',
          borderTop: '1px solid #e5e5e5',
          borderLeft: '1px solid #e5e5e5',
          borderRight: '1px solid #e5e5e5',
          p: 1,
          bgcolor: NAV_SURFACE,
          backgroundColor: NAV_SURFACE,
          backgroundImage: 'none',
        }}
      >
        <BottomNavigationAction
          label="Turns"
          icon={<FormatListNumberedOutlinedIcon />}
          sx={{
            '&.Mui-selected': {
              color: 'black', // Change active icon and label color to black
            },
          }}
        />
        <BottomNavigationAction
          label="Services"
          icon={<AddToPhotosOutlinedIcon />}
          sx={{
            '&.Mui-selected': {
              color: 'black', // Change active icon and label color to black
            },
          }}
        />
        <BottomNavigationAction
          label="S.Detail"
          icon={<PlaylistAddOutlinedIcon />}
          sx={{
            '&.Mui-selected': {
              color: 'black', // Change active icon and label color to black
            },
          }}
        />
        <BottomNavigationAction
          label="Manager"
          icon={<AssignmentOutlinedIcon />}
          sx={{
            '&.Mui-selected': {
              color: 'black', // Change active icon and label color to black
            },
          }}
        />
      </BottomNavigation>

      {/* Sliding Box */}
      <Slide direction="up" in={isBoxOpen} mountOnEnter unmountOnExit>
        <div
          ref={slidingBoxRef}
          className="max-w-md mx-auto"
          style={{
            position: 'fixed',
            bottom: '55px',
            left: '10px',
            right: '10px',
            height: '340px',
            zIndex: 50,
            backgroundColor: SHEET_SURFACE,
            borderTopLeftRadius: '20px',
            borderTopRightRadius: '20px',
            boxShadow: '0 -10px 24px rgba(15, 23, 42, 0.18), 0 -2px 6px rgba(15, 23, 42, 0.08)',
          }}
          onClick={stopPropagation}
        >
          <div
            className="sliding-box"
            style={{
              height: '100%',
              backgroundColor: SHEET_SURFACE,
              border: '1px solid #e5e5e5',
              borderBottom: 'none',
              borderTopLeftRadius: '20px',
              borderTopRightRadius: '20px',
              padding: '0 15px',
              overflowY: 'auto',
            }}
          >
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              {value === 0 && tab1}
              {value === 1 && tab2}
              {value === 2 && tab3}
              {value === 3 && tab4}
            </div>
          </div>
        </div>
      </Slide>
    </div>
  );
};

// Add prop validation using PropTypes
TaskManager_AdminMenu.propTypes = {
  tab1: PropTypes.node.isRequired, // tab1 is a required React node (can be any JSX component)
  tab2: PropTypes.node.isRequired, // tab2 is a required React node
  tab3: PropTypes.node.isRequired, // tab3 is a required React node
  tab4: PropTypes.node.isRequired, // tab4 is a required React node
};

export default TaskManager_AdminMenu;
